export const LANDSCAPE_LAYOUT = "landscape";
export const PORTRAIT_LAYOUT = "portrait";
